import { render } from "./Index.vue?vue&type=template&id=869945d8&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=869945d8&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869945d8"]])

export default __exports__